/**
 * The diorama's tilt-shift (68.13; lane E's camera sheet, design_sheets/camera.html — Toy Soldiers' toy-box look): two
 * bands, top and bottom, a backdrop blur faded toward the middle by a gradient mask, and a slight lift of saturation and
 * contrast on the game's canvas. Exactly the sheet's recipe, so the game reads as the sheet does. `set(amount)` fades it
 * (the camera stop's `tilt`, 0–1). **On by default** (the owner, Oct 11, after trying both: "I think tiltshift 1 is the
 * only one that works, it's cool and is the one I prefer"); the Lab's Diorama tilt-shift row or `?tiltshift=0` turns it
 * off. Decision 136: headless (CPU WebGL) at 25 a side it took the diorama's mean frame from 104 to 135 ms; the owner
 * chose it on his GPU.
 */
let override: boolean | null = null;
/** The Lab's row (null = the default: on, unless the URL says `tiltshift=0`). */
export function setTiltShiftEnabled(v: boolean | null): void { override = v; }
export function tiltShiftEnabled(): boolean {
  if (override !== null) return override;
  try { return typeof location === 'undefined' || new URLSearchParams(location.search).get('tiltshift') !== '0'; } catch { return true; }
}

export class TiltShift {
  private bands: HTMLDivElement[];
  private amount = -1;

  constructor(private canvas: HTMLCanvasElement) {
    const band = (top: boolean) => {
      const el = document.createElement('div');
      const mask = `linear-gradient(to ${top ? 'bottom' : 'top'}, #000 30%, transparent)`;
      el.style.cssText = `position:fixed; left:0; right:0; ${top ? 'top' : 'bottom'}:0; height:38vh; pointer-events:none; z-index:8; opacity:0; display:none; backdrop-filter:blur(5px); -webkit-backdrop-filter:blur(5px); mask-image:${mask}; -webkit-mask-image:${mask};`;
      document.body.appendChild(el);
      return el;
    };
    this.bands = [band(true), band(false)];
  }

  /** Fade the effect in (`amount` 0–1); 0 removes it entirely (no blur pass while off). */
  set(amount: number): void {
    const a = tiltShiftEnabled() ? Math.max(0, Math.min(1, amount)) : 0;
    if (Math.abs(a - this.amount) < 0.01) return;
    this.amount = a;
    // 68.14: the bands narrow with the amount (the squad stop's 0.45 blurs the edges, the diorama's 1 the sheet's 38vh)
    for (const el of this.bands) { el.style.display = a > 0.01 ? '' : 'none'; el.style.opacity = String(a); el.style.height = `${(22 + 16 * a).toFixed(1)}vh`; }
    this.canvas.style.filter = a > 0.01 ? `saturate(${1 + 0.3 * a}) contrast(${1 + 0.06 * a})` : '';
  }

  dispose(): void { this.set(0); for (const el of this.bands) el.remove(); }
}
